module.exports = __webpack_public_path__ + "static/media/icon-clip-light-blue.37b02e5c.svg";